import { Link } from 'react-router-dom'

import { Card, Input, Spinner } from '../../../../components'
import { UserItem } from '../../../../components/user-item'
import { UserItemProps } from '../../../../components/user-item/user-item'
import { UsersListPlaceholder } from './users-list-placeholder'

interface UsersProps {
    users: UserItemProps[]
    setSearch: (str: string) => void
    search: string
    loading: boolean
}

export function Users({ users, setSearch, search, loading }: UsersProps) {
    return (
        <div
            className='grid h-full grid-cols-8 gap-8 p-8 overflow-hidden'
            style={{}}>
            <Card className='col-span-3'>
                <h1>Search for users</h1>

                <Input
                    placeholder='matias@masa.finance...'
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                />
            </Card>

            <div className='flex flex-col col-span-5 p-4 overflow-scroll scrollbar-hide gap-y-4'>
                {users?.length === 0 ? (
                    loading ? (
                        <div className='flex items-center justify-center w-full h-full'>
                            <Spinner />
                        </div>
                    ) : (
                        <UsersListPlaceholder />
                    )
                ) : null}
                {users.map(u => (
                    <Link to={`/masa/user/${u.id}`}>
                        <UserItem {...u} />
                    </Link>
                ))}
            </div>
        </div>
    )
}
